
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5tKh7", function(module, exports) {

$parcel$export(module.exports, "EditorPageCoverPictureEntry", () => $fdbc267ab6414ddb$export$e8a47c72fec9e984);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $dyQl7 = parcelRequire("dyQl7");

var $i5zxs = parcelRequire("i5zxs");
// This component is necessary since we only want to check if isTitleHovered/userOffline for pages without cover photos.
// It determines what props will get passed to EditorCoverPicture and renders it.
// Passing the isTitleHovered prop to pages with cover photos causes an unwanted flicker effect if the title is hovered.
// Similarly if we pass userOffline to a page with a cover picture and the page goes offline,
// the image disappears since it is fetched from the media API but there is no internet, causing the image to return as null
const $fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent = ({ contentId: contentId, isTitleHovered: isTitleHovered, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, width: width, leftOffset: leftOffset, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, hasCoverPicture: hasCoverPicture, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, isUnsplash: isUnsplash })=>{
    // We need this modal state since if there's no cover picture and the modal is open, we don't want to pass the isTitleHovered prop
    // to EditorPageCoverPicture. If passed, this prop causes a bunch of re-renders if the modal is interacted with, making it impossible to
    // use the modal as isTitleHovered keeps getting updated.
    const [isModalOpen, setIsModalOpen] = (0, $gwFzn.useState)(false);
    if (hasCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "has-cover-picture-component",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            position: isFixedWidthImageOption ? 'relative' : 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: (0, $9wGTI.fg)('confluence_frontend_remove_cover_image_left_gap') ? '0px' : `${leftOffset}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dyQl7.LazyEditorPageCoverPicture), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
        isUnsplash: isUnsplash,
        isFixedWidthImageOption: isFixedWidthImageOption
    }));
    else if (isModalOpen && !hasCoverPicture) // omit isTitleHovered prop since it causes re-renders if the modal is open and interacted with if the page has no cover picture
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "no-cover-picture-component-modal-open"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dyQl7.LazyEditorPageCoverPicture), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        setIsModalOpen: setIsModalOpen,
        isModalOpen: isModalOpen,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
    }));
    else // no cover picture and modal isn't open
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "no-cover-picture-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dyQl7.LazyEditorPageCoverPicture), {
        contentId: contentId,
        isTitleHovered: isTitleHovered,
        isPublishingContent: isPublishingContent,
        contentType: contentType,
        userOffline: userOffline,
        setIsModalOpen: setIsModalOpen,
        isModalOpen: isModalOpen,
        hasCoverPicture: hasCoverPicture,
        coverPictureState: coverPictureState,
        isUnpublishedDraft: isUnpublishedDraft,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isReadOnly: isReadOnly,
        aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
    }));
};
const $fdbc267ab6414ddb$export$e8a47c72fec9e984 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent, {
            ...props,
            coverPictureState: coverPictureState
        })));

});
parcelRegister("dyQl7", function(module, exports) {

$parcel$export(module.exports, "LazyEditorPageCoverPicture", () => $7cc006105e2a4093$export$cc835f6c4a40c9c0);

var $jmjWc = parcelRequire("jmjWc");

var $e7fq5 = parcelRequire("e7fq5");

const $7cc006105e2a4093$export$cc835f6c4a40c9c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TpAT",
    name: "LazyEditorPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("bQa86"))).EditorPageCoverPicture;
    },
    loading: (0, $e7fq5.EditorPageCoverPicturePlaceholder)
});

});
parcelRegister("e7fq5", function(module, exports) {

$parcel$export(module.exports, "EditorPageCoverPicturePlaceholder", () => $4e2549f598bdb9fe$export$6ab910d41613f405);
/* EditorPageCoverPicturePlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $7aRa9 = parcelRequire("7aRa9");
const $4e2549f598bdb9fe$var$Placeholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1isxe5u": (0, $iAWao.default)(`${__cmplp.dynamicCoverImageHeight}px`)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q711bn _2rko1l7b _kqswh2mm _1bsb1osq _4t3i1v90",
            __cmplp.className
        ])
    });
});
const $4e2549f598bdb9fe$export$6ab910d41613f405 = (0, $7aRa9.withFlags)((props)=>{
    return props.hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4e2549f598bdb9fe$var$Placeholder, null) : null;
});

});

parcelRegister("bQa86", function(module, exports) {

let $89ec688fb933c07c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $89ec688fb933c07c$var$load("hDR7w"),
    $89ec688fb933c07c$var$load("8miHS"),
    $89ec688fb933c07c$var$load("27VjJ"),
    $89ec688fb933c07c$var$load("HYlkB"),
    $89ec688fb933c07c$var$load("8oTM2"),
    $89ec688fb933c07c$var$load("ih92g"),
    $89ec688fb933c07c$var$load("2F69B"),
    $89ec688fb933c07c$var$load("eAnbE"),
    $89ec688fb933c07c$var$load("hzK1f"),
    $89ec688fb933c07c$var$load("fqrMn"),
    $89ec688fb933c07c$var$load("fYi1a"),
    $89ec688fb933c07c$var$load("bjzRn"),
    $89ec688fb933c07c$var$load("8mzoy"),
    $89ec688fb933c07c$var$load("7a9CL"),
    $89ec688fb933c07c$var$load("ivQYH"),
    $89ec688fb933c07c$var$load("8pE8S"),
    $89ec688fb933c07c$var$load("9Bu2S"),
    $89ec688fb933c07c$var$load("42vdC"),
    $89ec688fb933c07c$var$load("P5iE2"),
    $89ec688fb933c07c$var$load("6ACCg"),
    $89ec688fb933c07c$var$load("kIjBt"),
    $89ec688fb933c07c$var$load("aZinD"),
    $89ec688fb933c07c$var$load("ffEVr"),
    $89ec688fb933c07c$var$load("joJy8"),
    $89ec688fb933c07c$var$load("aHE9G"),
    $89ec688fb933c07c$var$load("gGhXk")
]).then(()=>parcelRequire('4hoOb'));

});




//# sourceMappingURL=EditorPageCoverPictureEntry.26bfb7e0.js.map
